import { Controller } from "@hotwired/stimulus"

const INTRO_KEY = "floosyo:reports-intro-played"

// One decision per Turbo page view: had the reports intro already played
// before this visit? The first visit reads false and immediately marks the
// intro as played, so every later visit renders settled. The answer is
// cached per page view so every reveal/counter controller on the same
// render agrees (otherwise the first controller to connect would flip the
// flag and starve the rest).
let playedBeforeThisVisit = null
document.addEventListener("turbo:visit", () => { playedBeforeThisVisit = null })

export function reportsIntroAlreadyPlayed() {
  if (playedBeforeThisVisit === null) {
    try {
      playedBeforeThisVisit = localStorage.getItem(INTRO_KEY) === "1"
      if (!playedBeforeThisVisit) localStorage.setItem(INTRO_KEY, "1")
    } catch (_) {
      playedBeforeThisVisit = false
    }
  }
  return playedBeforeThisVisit
}

// Scroll-entrance reveal for report cards. Hides the card only once JS is
// active (no-JS users always see content), then fades it in and releases its
// held child animations (.ring-anim, .bar-grow, .seg-grow, .trend-grow) the
// first time it enters the viewport. The whole choreography is a one-time
// wow moment: after it has played once on this device it never replays —
// later visits render settled instantly. Respects prefers-reduced-motion.
//
// Usage: <div class="glass-card" data-controller="reveal">...</div>
export default class extends Controller {
  connect() {
    if (this.prefersReducedMotion() || reportsIntroAlreadyPlayed()) {
      this.element.classList.add("reveal-static")
      return
    }

    this.element.classList.add("reveal-pending")
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        this.element.classList.add("reveal-in")
        this.observer.disconnect()
      })
    }, { threshold: 0.15, rootMargin: "0px 0px -30px 0px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
